module.exports = __webpack_public_path__ + "static/img/UTSC老师_火花.914eae9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/UTSC/UTSC老师_火花.png
// module id = s8DY
// module chunks = 0